import { ASSET_URL } from "../../config";

/**
 * Résout une URL d'image : absolue ou relative à ASSET_URL.
 */
export function resolveImage(img) {
    if (!img) return null;
    if (/^https?:\/\//i.test(img)) return img;
    return `${ASSET_URL}${img}`;
}

/**
 * URL externe absolue ou interne préfixée par BASE_WEB_URL.
 */
export function resolveUrl(org, url) {
    if (!url) return null;
    if (/^https?:\/\//i.test(url)) return url;
    return (org?.BASE_WEB_URL || "") + url;
}

/**
 * Sections homepage par défaut quand aucun ordre n'est configuré côté admin.
 * Toutes universelles, aucune religion forcée. L'ordre est volontaire :
 *  events → caisses (CTA fort) → horaires → articles → galerie → bannières
 *
 * Note : la Newsletter n'est PAS dans la home — elle est par défaut en
 * pré-footer (cf. DEFAULT_PRE_FOOTER_SECTIONS) pour être présente sur
 * toutes les pages du site, pas seulement la home.
 */
export const DEFAULT_HOME_SECTIONS = [
    { id: "EVENTS_PREVIEW",   type: "EVENTS_PREVIEW",   label: "Événements",      editable: false, hidden: false },
    { id: "CAISSES_PREVIEW",  type: "CAISSES_PREVIEW",  label: "Soutenir",        editable: false, hidden: false },
    { id: "HORAIRES_PREVIEW", type: "HORAIRES_PREVIEW", label: "Horaires",        editable: false, hidden: false },
    { id: "ARTICLES_PREVIEW", type: "ARTICLES_PREVIEW", label: "Actualités",      editable: false, hidden: false },
    { id: "GALLERY_PREVIEW",  type: "GALLERY_PREVIEW",  label: "Galerie",         editable: false, hidden: false },
    { id: "BANNERS_INLINE",   type: "BANNERS",          label: "Bannières",       editable: false, hidden: false, props: { source: "banners.items" } },
    // Section MAIN_CONTENT : rend org.mainPage (rich content éditeur). Auto-masquée
    // si l'org n'a pas de mainPage (le composant retourne null silencieusement).
    { id: "MAIN_CONTENT",     type: "MAIN_CONTENT",     label: "Page principale", editable: false, hidden: false },
];

/**
 * Sections globales pré-footer par défaut : Newsletter présente sur toutes
 * les pages (placée systématiquement en dernier avant le footer par ThemeRoot).
 */
export const DEFAULT_PRE_FOOTER_SECTIONS = [
    { id: "NEWSLETTER_GLOBAL", type: "NEWSLETTER", label: "Newsletter", editable: false, hidden: false },
];

/**
 * Récupère un tableau dans config en supportant la notation pointée OU
 * la notation imbriquée. Permet à l'admin de stocker indifféremment :
 *   config["home.sections"] = [...]   OU   config.home = { sections: [...] }
 */
export function readArrayFromConfig(config, path, fallback = []) {
    if (!config) return fallback;
    if (Array.isArray(config[path])) return config[path];
    const parts = path.split(".");
    let cur = config;
    for (const p of parts) {
        if (cur == null) return fallback;
        cur = cur[p];
    }
    return Array.isArray(cur) ? cur : fallback;
}

/**
 * Idem pour un objet quelconque.
 */
export function readFromConfig(config, path, fallback = null) {
    if (!config) return fallback;
    if (config[path] !== undefined) return config[path];
    const parts = path.split(".");
    let cur = config;
    for (const p of parts) {
        if (cur == null) return fallback;
        cur = cur[p];
    }
    return cur === undefined ? fallback : cur;
}
